import { DeviceStatusIcon } from '../components/DeviceStatusBadge';
import { HardwareStatusSummary } from '../types/hardwareStatus';

export const getDeviceStatusIcon = (status?: HardwareStatusSummary): DeviceStatusIcon => {
  if (!status || status.status === 'unknown') {
    return 'unknown';
  }
  if (status.variant === 'danger' || status.variant === 'warning') {
    return 'warning';
  }

  return 'device';
};

export const getLockStatusIcon = (status?: HardwareStatusSummary): DeviceStatusIcon => {
  if (!status || status.status === 'unknown' || status.status === 'not_available') {
    return 'unknown';
  }
  if (status.status === 'unlocked' || status.status === 'open' || status.status === 'opening') {
    return 'unlock';
  }
  if (status.status === 'locked' || status.status === 'closed' || status.status === 'closing') {
    return 'lock';
  }

  return 'warning';
};
